import { render, staticRenderFns } from "./TippTitle.vue?vue&type=template&id=c6a2dcca&scoped=true&"
import script from "./TippTitle.vue?vue&type=script&lang=js&"
export * from "./TippTitle.vue?vue&type=script&lang=js&"
import style0 from "./TippTitle.vue?vue&type=style&index=0&id=c6a2dcca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a2dcca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
